import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=545c8f00&"
import script from "./PersonList.vue?vue&type=script&lang=js&"
export * from "./PersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports